import useAppContext from 'flow/hooks/useAppContext';
import { useEffect } from 'react';

const ServiceUnavailableComponent = () => {
    const { i18next } = useAppContext();
    useEffect(() => {
        document.title = i18next.t('service_unavailable.title');
    }, []);

    return (
        <div className="flex h-full w-full flex-col items-center justify-center bg-gray-100">
            <div className="rounded bg-white p-6 text-center shadow-md">
                <h2 className="text-xl font-bold">
                    {i18next.t('service_unavailable.title')}
                </h2>
                <p>{i18next.t('service_unavailable.description')}</p>
            </div>
        </div>
    );
};

export default ServiceUnavailableComponent;
